import "./vendor";
import "./stylesheets/common";
import "./stylesheets/application";
import "./startup";
import "./notice";
import "./pages/index";
import "./pages/courses/index";
import "./pages/user_profile/index";
import "./pages/usersettings/change_password";
import "./pages/usersettings/edit";
import "./pages/samples/pdf_viewer";
import "./pages/entries/create";
import './areas/manage/pages/users/index';
import "./pages/courses/index";
import "./pages/courses/details";
import "./pages/contents/index";
import "./pages/passwordResets/create";
